import { Injectable } from '@angular/core';
import { BaseViewModel } from '../../../../models/base/base-view-model';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';

@Injectable()
export class DashboardViewModel extends BaseViewModel {
  constructor(private router: Router) {
    super();
  }

  public readonly isBudBot$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map(() => this.isBudBotUrl()),
    startWith(this.isBudBotUrl())
  );

  private isBudBotUrl(): boolean {
    return this.router.url?.includes('budbot');
  }
}
